export default "__VITE_ASSET__4ae3adf1__"